import { ReactNode, useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { EnsoProvider, PageSpinner } from '@ohpen/enso-ui';
import { IConfig, ConfigContext, getCdnAssets } from '@ohpen/react-utils';
import { AuthProvider } from '@ohpen/react-auth';

import { AppRoutes } from './router';
import { getOidcConfig } from '@pmp/utils';
import { HarnessAuthProvider } from '@pmp/contexts';

export const App = ({ config }: { config: IConfig }) => {
  const tenantClient = config?.CLIENT || 'ohp';
  const assetsBaseUrl = config?.THEMING?.ASSETS_BASE_URL || 'https://cdn.portal.ohpen.tech';
  const enableCredentials = config?.AWS?.ENABLE_CREDENTIALS_LOGIN ?? false;
  const oidcConfig = getOidcConfig(config);
  const [themeLoaded, setThemeLoaded] = useState(false);

  const amplifyConfig = {
    enableCredentials,
    userPoolId: config.AWS.USER_POOL_ID,
    userPoolClientId: config.AWS.USER_POOL_APP_CLIENT_ID,
  };

  useEffect(() => {
    getCdnAssets(config).then(() => setThemeLoaded(true));
  }, [config]);

  const authWrapper = (children: ReactNode) =>
    config.HARNESS_MODE ? (
      <HarnessAuthProvider>{children}</HarnessAuthProvider>
    ) : (
      <AuthProvider oidcConfig={oidcConfig} amplifyConfig={amplifyConfig}>
        {children}
      </AuthProvider>
    );

  return (
    <ConfigContext.Provider value={config}>
      <EnsoProvider client={tenantClient} assetsBaseUrl={assetsBaseUrl}>
        {authWrapper(<BrowserRouter>{themeLoaded ? <AppRoutes /> : <PageSpinner />}</BrowserRouter>)}
      </EnsoProvider>
    </ConfigContext.Provider>
  );
};
